/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Bug_TriageInputs */

const en_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bug triage`)
};

const ar_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرز الأخطاء`)
};

const bn_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাগ বাছাই`)
};

const de_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlertriage`)
};

const es_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación de errores`)
};

const fr_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triage de bugs`)
};

const pt_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triagem de erros`)
};

const zh_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缺陷分诊`)
};

const tr_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hata triyajı`)
};

const ru_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Триаж багов`)
};

const pl_svchip_bug_triage = /** @type {(inputs: Svchip_Bug_TriageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triaż błędów`)
};

/**
* | output |
* | --- |
* | "Bug triage" |
*
* @param {Svchip_Bug_TriageInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_bug_triage = /** @type {((inputs?: Svchip_Bug_TriageInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Bug_TriageInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_bug_triage(inputs)
	if (locale === "bn") return bn_svchip_bug_triage(inputs)
	if (locale === "de") return de_svchip_bug_triage(inputs)
	if (locale === "es") return es_svchip_bug_triage(inputs)
	if (locale === "fr") return fr_svchip_bug_triage(inputs)
	if (locale === "pt") return pt_svchip_bug_triage(inputs)
	if (locale === "zh") return zh_svchip_bug_triage(inputs)
	if (locale === "tr") return tr_svchip_bug_triage(inputs)
	if (locale === "ru") return ru_svchip_bug_triage(inputs)
	if (locale === "pl") return pl_svchip_bug_triage(inputs)
	return en_svchip_bug_triage(inputs)
});